import { createFileRoute } from '@tanstack/react-router';

import { ArticleCreate } from '@/module/Author/Article/ArticleCreate';

export const Route = createFileRoute('/_auth/author/_author/article/_article/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ArticleCreate />;
}
